export enum AuthTypes {
  Tab = 'tab',
  Popup = 'popup',
}
